import * as React from 'react';
import * as hash from 'object-hash';
import { IRecipientContactInformation, IUsPsAddressResponse } from '@nkr/models/index';
import { IAddress } from '@nkr/components/address-validation';

interface IAddressValidation {
    show: boolean,
    response: IUsPsAddressResponse
    submittedAddress: IAddress
}

interface IState {
    hash: string,
    data: IRecipientContactInformation,
    originalData: {
        address: string,
        address2: string,
        city: string,
        state: string,
        postalCode: string,
    },
    birthDateValid: boolean,
    addressValidation: IAddressValidation,
}

const initialState: IState = {
    hash: '',
    data: null,
    originalData: {
        address: '',
        address2: '',
        city: '',
        state: '',
        postalCode: ''
    },
    birthDateValid: true,
    addressValidation: {
        show: false,
        response: null,
        submittedAddress: null
    },
};

type Action =
    | { type: 'afterLoad', payload: IRecipientContactInformation }
    | { type: 'updateHash', payload: string }
    | { type: 'updateData', payload: IRecipientContactInformation }
    | { type: 'addressValidation', payload: IAddressValidation }
    | { type: 'useAddress', payload: { data: IRecipientContactInformation, addressValidation: IAddressValidation } }
    | { type: 'updateBirthDateValid', payload: boolean }
    ;

const contactInfoReducer: React.Reducer<IState, Action> = (state, action) => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.payload,
            originalData: {
                address: action.payload.address,
                address2: action.payload.address2,
                city: action.payload.city,
                state: action.payload.state,
                postalCode: action.payload.postalCode
            },
            hash: hash(action.payload),
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.payload };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.payload };
    }

    if (action.type == 'addressValidation') {
        return { ...state, addressValidation: action.payload };
    }

    if (action.type == 'useAddress') {
        return { ...state, data: action.payload.data, addressValidation: action.payload.addressValidation };
    }

    if (action.type == 'updateBirthDateValid') {
        return { ...state, birthDateValid: action.payload };
    }

    return { ...state };
};


export { IState, initialState, contactInfoReducer };